// extracted by mini-css-extract-plugin
module.exports = {"canceled":"Registrations_canceled__tqxvo","selects":"Registrations_selects__3sGij","Container":"Registrations_Container__mpUxe"};